import * as React from 'react'
import styles from './index.module.css'

type Props = {
  contentState: Record<string, any>
  entityKey: string
  children: React.ReactNode
  rel: string
  target: string
}

const Link = (props: Props): React.ReactElement<'a'> => {
  const { url } = props.contentState.getEntity(props.entityKey).getData()
  const { rel, target } = props
  return (
    <a
      className={styles.richEditorCustomLink}
      href={url}
      rel={rel}
      target={target}
    >
      {props.children}
    </a>
  )
}

export default Link
